import { gConsts } from '@/globals/gConsts';

export const TIPO_ANOTACAO_TO_TIPO_ASSOCIACAO = {
    [gConsts.node.report.annotation.types.FIXED]: gConsts.node.report.annotation.association.GROUP,
    [gConsts.node.report.annotation.types.RX_SIDE]: gConsts.node.report.annotation.association.GROUP,
    [gConsts.node.report.annotation.types.TOOTH]: gConsts.node.report.annotation.association.INDIVIDUAL,
    [gConsts.node.report.annotation.types.RTOOTH]: gConsts.node.report.annotation.association.INDIVIDUAL,
    [gConsts.node.report.annotation.types.ANAT_ONLY]: gConsts.node.report.annotation.association.INDIVIDUAL,
    [gConsts.node.report.annotation.types.ANAT_RTOOTH]: gConsts.node.report.annotation.association.INDIVIDUAL,
    [gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH]: gConsts.node.report.annotation.association.INDIVIDUAL,
}